import React, { useState, useRef, useEffect } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import CompanionChatBox from './CompanionChatBox';
import companionImage from '../../images/companion_icon.svg';
import useStore from '../../Store/Store';

const useStyles = makeStyles((theme) => ({
  companionIcon: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: '50%',
    transform: 'translateX(50%)',
    width: '80px',
    height: '80px',
    cursor: 'pointer',
    zIndex: 1000,
    [theme.breakpoints.up('sm')]: {
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      transform: 'none',
    },
  },
  chatContainer: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    width: '100%',
    maxWidth: '560px',
    height: '500px',
    backgroundColor: '#fff',
    borderRadius: theme.spacing(1),
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    zIndex: 1000,
    overflow: 'hidden',
    '@media (max-width: 600px)': {
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      bottom: 0,
      right: 0,
      top: 0,
      left: 0,
      margin: 0,
      borderRadius: 0,
      position: 'fixed',
    },
  },
}));

const CompanionChat = ({ handleClose }) => {
  const classes = useStyles();
  const [showChat, setShowChat] = useState(false);
  const chatRef = useRef(null);
  const location = useLocation();
  const user = useStore((state) => state.user);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (chatRef.current && !chatRef.current.contains(event.target)) {
        setShowChat(false);
        handleClose && handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClose]);

  const toggleChat = () => {
    setShowChat(!showChat);
  };

  // Hide chat on login and register pages
  const shouldShowChat = !(location.pathname === '/login' || location.pathname === '/sign-up' || !user);

  if (!shouldShowChat) {
    return null;
  }

  return (
    <>
      {!showChat ? (
        <img src={companionImage} alt="Companion Chat" className={classes.companionIcon} onClick={toggleChat} />
      ) : (
        <Box ref={chatRef} className={classes.chatContainer}>
          <CompanionChatBox
            handleClick={() => {
              toggleChat();
              handleClose && handleClose();
            }}
          />
        </Box>
      )}
    </>
  );
};

export default CompanionChat;
